module.exports = __webpack_public_path__ + "img/bullet_12.f268a653.svg";